import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { RECOMMENDATIONS_API } from '../../constants/central-api';
import { applicationWWWXRLEncodedBodyBuilder } from '../../utils/body-builder';

export default async function toggle_automated_recommendation_api_call(
  recommendationId: string,
  enabled: boolean
) {
  const accessToken = store.getState().user?.stats?.ai_tracker_access_token;

  if (!accessToken) {
    return false;
  }

  const requestInfo: RequestInfo = {
    url: `${RECOMMENDATIONS_API}/${recommendationId}/status`,
    method: 'PATCH',
    body: applicationWWWXRLEncodedBodyBuilder({
      status: enabled ? '1' : '0',
    }),
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${accessToken}`,
    },
  };

  const actionType = 'TOGGLE_AUTOMATED_RECOMMENDATION';
  const customMsg = enabled
    ? 'Recommendation enabled successfully'
    : 'Recommendation disabled successfully';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false,
    true,
    false,
    true
  );

  const response = res?.data;
  if (!response?.success) {
    return false;
  }
  if (res?.actionType === actionType && response?.success === true) {
    return true;
  }
}
